import { Card } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

interface Props {
  children: React.ReactNode;
}

function LicenseCard({ children }: Props) {
  return (
    <Card radius="lg" className="p-3 mb-[2%]">
      {children}
    </Card>
  );
}

export default observer(LicenseCard);
